module.exports = __webpack_public_path__ + "static/keycrime-logo-b8813d31c560d15d28b1a54c6b7031d3.png";